<template>
  <div class="custom-forgot">
    <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
      {{ status }}
    </div>

    <breeze-validation-errors class="mb-4" />

    <form @submit.prevent="submit">
      <div class="form-floating mb-4 text-center">
        <img src="/media/live/logo.png" alt="Corsync" class="logo" />
      </div>
      <div class="form-floating mb-4 text-center">
        <h4>Forgot your Password?</h4>
      </div>
      <div class="form-floating mb-4">
        <p>No problem.</p>
        <p>
          Supply your email address below and we'll send you a password reset
          link that'll allow you to choose a new one.
        </p>
      </div>

      <div class="form-floating mb-4">
        <breeze-label for="email" value="Email" v-show="form.email === ''" />
        <breeze-input
          id="email"
          type="email"
          class="form-control"
          v-model="form.email"
          required
          autofocus
          autocomplete="username"
        />
      </div>
      <div class="form-floating mb-4 text-center">
        <breeze-button
          :class="{ 'opacity-25': form.processing }"
          :disabled="form.processing"
          class="btn btn-primary"
        >
          Send Password Reset Link
        </breeze-button>
      </div>
      <div class="form-floating mb-4 text-center">
        <inertia-link href="/login" class="btn btn-link"> Login </inertia-link>
      </div>
    </form>
  </div>
</template>
<script>
import BreezeButton from '@/Components/Elements/Button'
import BreezeInput from '@/Components/Elements/Input'
import BreezeLabel from '@/Components/Elements/Label'
import BreezeValidationErrors from '@/Components/Elements/ValidationErrors'
export default {
  components: {
    BreezeButton,
    BreezeInput,
    BreezeLabel,
    BreezeValidationErrors,
  },
  props: {
    status: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
      }),
    }
  },
  methods: {
    submit() {
      this.form.post(this.route('password.email'))
    },
    gotoLogin() {},
  },
}
</script>
<style lang="scss" scoped>
.logo {
  height: 64px;
  width: auto;
}
.custom-forgot {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: auto;
}
.custom-label {
  position: relative;
  top: 0;
}
</style>
